import { render, staticRenderFns } from "./wagesGzList.vue?vue&type=template&id=3db7ec58&scoped=true&"
import script from "./wagesGzList.vue?vue&type=script&lang=js&"
export * from "./wagesGzList.vue?vue&type=script&lang=js&"
import style0 from "./wagesGzList.vue?vue&type=style&index=0&id=3db7ec58&scoped=true&lang=css&"
import style1 from "./wagesGzList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db7ec58",
  null
  
)

export default component.exports